import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Timeline } from '@primer/react';

var TimelineItem = function TimelineItem(_a) {
  var badgeClasses = _a.badgeClasses,
    badgeIcon = _a.badgeIcon,
    children = _a.children,
    className = _a.className,
    _b = _a.condensed,
    condensed = _b === void 0 ? false : _b,
    _c = _a.extraStyles,
    extraStyles = _c === void 0 ? {} : _c,
    rest = __rest(_a, ["badgeClasses", "badgeIcon", "children", "className", "condensed", "extraStyles"]);
  return /*#__PURE__*/React.createElement(Timeline.Item, __assign({
    className: className,
    condensed: condensed,
    sx: __assign({
      alignItems: "center"
    }, extraStyles)
  }, rest), badgeIcon && /*#__PURE__*/React.createElement(Timeline.Badge, {
    className: badgeClasses,
    sx: {
      borderColor: "timeline.badgeBorder"
    }
  }, badgeIcon), children);
};
var TimelineBody = function TimelineBody(_a) {
  var className = _a.className,
    children = _a.children,
    extraStyles = _a.extraStyles,
    rest = __rest(_a, ["className", "children", "extraStyles"]);
  return /*#__PURE__*/React.createElement(Timeline.Body, __assign({
    className: className,
    sx: extraStyles
  }, rest), children);
};
var LTTimeline = function LTTimeline(_a) {
  var _b = _a.className,
    className = _b === void 0 ? "" : _b,
    children = _a.children,
    _c = _a.extraStyles,
    extraStyles = _c === void 0 ? {} : _c,
    _d = _a.politenessLevel,
    politenessLevel = _d === void 0 ? "polite" : _d;
  return /*#__PURE__*/React.createElement(Timeline, {
    className: className,
    sx: extraStyles,
    "aria-live": politenessLevel
  }, children);
};
LTTimeline.Item = TimelineItem;
LTTimeline.Body = TimelineBody;

export { LTTimeline as default };
